<template>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <p>Kunde: {{ entry.customer.name }}</p>
          </v-card-title>
          <v-card-title v-if="entry.project">
            <p>Projekt: {{ entry.project.name }}</p>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            Beschreibung: {{ entry.description }}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider></v-divider>
      <v-flex xs12>
        <v-toolbar flat>
          <v-toolbar-title>Zeiten</v-toolbar-title>
        </v-toolbar>
          <v-data-iterator
            :items="entry.timeEntries"
            content-tag="v-layout"
            row
            wrap
            hide-actions
            hide-headers

        >
              <v-flex
                xs12
                sm6
                md4
                lg3
                slot="item"
                slot-scope="props"
              >
                <v-card>
                                    <v-divider></v-divider>
                  <v-card-title>{{ props.item.worker.name }} am {{ props.item.date }}</v-card-title>
                  <v-card-text>Dauer: {{ props.item.duration }}</v-card-text>
                  <v-card-text>{{ props.item.description }}</v-card-text>
                  <v-divider></v-divider>
                </v-card>
              </v-flex>
            <template slot="no-data">
                <p>Keine Zeiten eingetragen!</p>
            </template>
        </v-data-iterator>
        <v-divider dark></v-divider>
        <v-toolbar flat>
          <v-toolbar-title>Artikel</v-toolbar-title>
        </v-toolbar>
        <v-data-table
            :items="entry.articleEntries"
            loading="true"
            hide-actions
            hide-headers
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.article.code }}</td>
                <td>{{ props.item.article.name }}</td>
                <td>{{ props.item.quantity }} {{ props.item.article.unit }}</td>
            </template>
            <template slot="no-data">
                <p>Keine Artikel eingetragen!</p>
            </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12>
        <v-divider></v-divider>
        <v-toolbar flat>
          <v-toolbar-title>Unterschrift</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="undo()" flat small>Feld leeren</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <signature width="350px" height="200px" saveType="image/svg+xml" ref="signaturePad" :customStyle=customStyle></signature>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Emailadresse"
          v-model="entry.mailadresses"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
          data-vv-name="email"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-btn
        color="primary"
        dark
        @click="saveRegie()"
      >Regiebericht absenden</v-btn>
      </v-flex>
    </v-layout>

</template>

<script>
import { REGIE_GET, REGIE_SAVE } from '../../store/actions/regie'
import VueSignaturePad from 'vue-signature-pad'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'signature': VueSignaturePad
  },
  data () {
    return {
      entry: {
        id: null,
        customer: null,
        project: null,
        timeEntries: [],
        articleEntries: [],
        description: '',
        mailadresses: ''
      },
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      customStyle: {
        border: 'black 1px solid',
        'max-width': '100%'
      }
    }
  },
  created () {
    this.$store.dispatch(REGIE_GET, this.$route.params.id).then(resp => {
      this.entry = resp
      this.entry.id = this.$route.params.id
      if (this.entry.project && this.entry.project.email) {
        this.entry.mailadresses = this.entry.project.email
      } else if (this.entry.customer && this.entry.customer.email) {
        this.entry.mailadresses = this.entry.customer.email
      }
    })
  },
  methods: {
    undo () {
      this.$refs.signaturePad.undoSignature()
    },
    saveRegie () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
          if (isEmpty) {
            this.$swal({
              type: 'error',
              title: 'Unterschrift fehlt',
              showConfirmButton: false,
              timer: 1000
            })
          } else {
            this.$swal.showLoading('Wird gesendet..')
            this.entry.signature = data
            this.$store.dispatch(REGIE_SAVE, this.entry).then(resp => {
              this.$swal({
                type: 'success',
                title: 'Eintrag erfolgreich hinzugefügt!',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push({ name: 'RegieIndex' })
            }).catch(err => {
              this.$swal({
                type: 'error',
                title: err.data.message,
                showConfirmButton: false,
                timer: 1500
              })
            })
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Regie/Sign.vue